(() => {
  class BioThriveQuiz extends HTMLElement {
    connectedCallback() {
      this.questions = Array.from(this.querySelectorAll("[data-bt-question]"));
      this.results = Array.from(this.querySelectorAll("[data-bt-result]"));
      this.current = 0;
      this.progress = this.querySelector("[data-bt-progress]");
      this.progressLabel = this.querySelector("[data-bt-progress-label]");
      this.backButton = this.querySelector("[data-bt-back]");
      this.nextButton = this.querySelector("[data-bt-next]");
      this.restartButtons = Array.from(this.querySelectorAll("[data-bt-restart]"));

      if (!this.questions.length) return;

      this.addEventListener("change", (event) => {
        if (event.target.matches("input[type='radio']")) this.updateButtons();
      });

      this.backButton?.addEventListener("click", () => this.previous());
      this.nextButton?.addEventListener("click", () => this.next());
      this.restartButtons.forEach((button) => button.addEventListener("click", () => this.restart()));

      this.showQuestion(0);
    }

    showQuestion(index) {
      this.current = Math.max(0, Math.min(index, this.questions.length - 1));
      this.questions.forEach((question, questionIndex) => {
        question.classList.toggle("is-active", questionIndex === this.current);
      });
      this.results.forEach((result) => result.classList.remove("is-active"));
      this.updateButtons();
    }

    selectedForCurrent() {
      return this.questions[this.current]?.querySelector("input[type='radio']:checked");
    }

    updateButtons() {
      const count = this.questions.length;
      const currentNumber = this.current + 1;
      if (this.progress) this.progress.style.width = `${(currentNumber / count) * 100}%`;
      if (this.progressLabel) this.progressLabel.textContent = `Question ${currentNumber} of ${count}`;
      if (this.backButton) this.backButton.disabled = this.current === 0;
      if (this.nextButton) {
        this.nextButton.disabled = !this.selectedForCurrent();
        this.nextButton.textContent = this.current === count - 1 ? this.dataset.resultButton || "See result" : this.dataset.nextButton || "Next";
      }
    }

    previous() {
      if (this.current > 0) this.showQuestion(this.current - 1);
    }

    next() {
      if (!this.selectedForCurrent()) return;
      if (this.current < this.questions.length - 1) {
        this.showQuestion(this.current + 1);
        return;
      }
      this.showResult();
    }

    showResult() {
      const scores = { glow: 0, metabolic: 0, vitality: 0 };
      this.questions.forEach((question) => {
        const selected = question.querySelector("input[type='radio']:checked");
        if (selected && scores[selected.value] !== undefined) scores[selected.value] += 1;
      });

      const winner = Object.entries(scores).sort((a, b) => b[1] - a[1])[0]?.[0] || "glow";
      this.questions.forEach((question) => question.classList.remove("is-active"));
      this.results.forEach((result) => result.classList.toggle("is-active", result.dataset.btResult === winner));
      if (this.progress) this.progress.style.width = "100%";
      if (this.progressLabel) this.progressLabel.textContent = this.dataset.recommendationLabel || "Your recommendation";
      if (this.backButton) this.backButton.disabled = true;
      if (this.nextButton) this.nextButton.disabled = true;
    }

    restart() {
      this.querySelectorAll("input[type='radio']").forEach((input) => {
        input.checked = false;
      });
      this.showQuestion(0);
    }
  }

  if (!customElements.get("biothrive-quiz")) {
    customElements.define("biothrive-quiz", BioThriveQuiz);
  }
})();
